import React, { useState, useEffect } from 'react';
import { Button, Tooltip, Row } from 'reactstrap';
import { faFile, faEdit, faImage, faCheck, faHourglassHalf, faFileDownload, faFileUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Link } from "react-router-dom";

//Imagem do Arquivo
import ImgArquivoBlue from "../../../assets/img/arquivoBlue.png"
import ImgArquivoVermelho from "../../../assets/img/arquivoVermelho.png"

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';
import downloadBase64File from '../../../helpers/downloadFile';

//API
import requerimento_api from '../../../api/requerimento';
import agenda_api from '../../../api/agenda_api';
import tipoCompensacao_api from '../../../api/tipoCompensacao_api';

//Context
import { useAuth } from '../../../context/auth';

//Components
import ModalCustomized from '../../../components/Modal/Modal';
import TextField from '../../../components/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

function initialStateAcao() {
    return {
        requerimento_Id: "",
        tipoRequerimentoEtapaAcao_Id: "",
        tipoRequerimentoEtapaProximaAcao_Id: "",
        tipoCompensacao_Id: "",
        numeroProcesso: "",
        acaoRealizada: "",
        identificacaoEtapa: "",
        usuario_Id: "",
        observacoes: "",
        dataHora: "",
        nomeUsuario: "",
        responsavel: "",
        dataAgendamento: "",
        formulario: {
            RequerimentoAcaoFormularioResposta: []
        },
        documentos: []
    }
}

export default function AcaoAtual({ requerimento, editavel, loadRequerimento, setDocumento, documentos, setDocumentos }) {
    //Estado para loading
    const { setLoading, session, setShowNavigation } = useAuth();

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState(false);

    //Estado de controle da ação que sera enviada para o back
    const [acao, setAcao] = useState(initialStateAcao);

    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle do valor do formulario da ação
    const [formulario, setFormulario] = useState(null);

    //Questão que esta sendo respondida do formulario
    const [questaoAtiva, setQuestaoAtiva] = useState(null);

    //Vetor que guarda as questões que foram respondidas
    const [questoesRespondidas, setQuestoesRespondidas] = useState([]);

    //Label do botão de enviar os dados do formulario
    const [labelBtnSubmit, setLabelBtnSubmit] = useState("Próximo");

    //Estado de controle de visibilidade do modal de agendamento
    const [visibleModalEdicaoAgendamento, setVisibleModalEdicaoAgendamento] = useState(false);

    //Estado de controle do formulario do agendamento selecionado
    const [formularioAgendamento, setFormularioAgendamento] = useState(null);

    //Estado de controle da imagem a ser exibida no modal de imagens do formulario
    const [imagemFormulario, setImagemFormulario] = useState(null);

    //Estado de controle da edição do agendamento
    const [agendamento, setAgendamento] = useState({
        id: "",
        dataAgendamento: ""
    });

    //Estado de controle dos tipos de compensação
    const [tiposCompensacao, setTiposCompensacao] = useState([]);

    //Função de onchange dos campos do requerimento searchable
    const onChangeSearchable = (value, e) => {
        setAcao({
            ...acao,
            [e.name]: value ? value.value : null,
        });

    }

    //Função que inicializa o id do agendamento para edição
    const editarAgendamento = (row) => {
        setAgendamento({
            ...agendamento,
            id: row.id,
            dataAgendamento: moment(row.dataAgendamento).format("YYYY-MM-DD")
        });
        toggleModalEdicaoAgendamento();
    }

    //Função de visualizar o agendamento no modal
    const visualizarAgendamento = (rowData) => {
        setFormularioAgendamento(rowData.formulario);
    }

    const editarVisualizarAgendamento = (rowData, actionStyle) => {
        //Controle dos endereços que podem ser editados na tabela
        if (!rowData.formulario) {
            return actionsTable.editar(() => editarAgendamento(rowData));
        } else {
            return actionsTable.visualizar(() => visualizarAgendamento(rowData));
        }
    }
    //Ações que a tabela terá
    const actions = [...editavel && (session.perfil == "Gestor" || session.perfil == "Master") ? [editarVisualizarAgendamento] : []];

    //Cabeçalhos que a tabela terá
    const headers = [
        {
            value: "Data do agendamento",
            objectValue: "dataAgendamento",
            align: "left",
            options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div>
                            {moment(requerimento.etapaAtual.agendamentosReplantio[dataIndex].dataAgendamento).format("DD/MM/YYYY")}
                        </div>
                    )
                }
            }
        },
        {
            value: "Status",
            objectValue: "status",
            align: "left",
        },
    ]

    //Tipos dos campos para as questões
    const typeOfFields = {
        "Lista": "select",
        "Lista Múltipla Seleção": "multiselect",
        "Texto": "text",
        "Data": "date",
        "Número": "text",
    }

    //Realiza o controle de visibilidade do modal do formulario
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
        if (visibleModal) {
            setFormulario(null);
            setQuestaoAtiva(null);
            setQuestoesRespondidas([]);
            setErrors(false);
            setLabelBtnSubmit("Próximo");
            setAcao(initialStateAcao);
        }
    }

    //Função responsavel por exibir as orientações dos documentos
    const toggleTooltip = (documento) => {
        setDocumentos(requerimento.etapaAtual.documentos.map(value => {
            if (value.id == documento.id)
                value.toolTip = !value.toolTip;
            else
                value.toolTip = false;
            return value;
        })
        )
    }

    //Ação realizada ao clicar no documento do card
    const handleClickCard = (ref) => {
        ref.current.click();
    };

    //Ação realizada ao clicar em baixar documento
    const downloadArquivoDocumento = (documento) => {
        if (documento.tipo == "Arquivo")
            downloadBase64File(documento.base64, documento.identificacao.trim() + '.pdf');
        else {
            setShowNavigation(false);
            setDocumento(documento);
        }
    }

    //Função de onChange do arquivo
    const handleFileChange = (documento, e, value) => {
        const FR = new FileReader();
        const documentoFiltro = acao.documentos.filter(x => x.documento_Id == documento.id);
        const fileData = documentoFiltro.length > 0
            ? documentoFiltro[0]
            : {
                documento_Id: documento.id,
                base64: "",
            };

        FR.addEventListener("load", function (evt) {
            fileData.base64 = evt.target.result;
            setAcao({
                ...acao,
                documentos: [
                    ...acao.documentos.filter(value => value.documento_Id != fileData.documento_Id),
                    fileData
                ]
            })
        });
        if (e.target.files)
            FR.readAsDataURL(e.target.files[0]);
    };

    //Função de onChange da ação
    const onChangeAcao = (e) => {
        const { name, value } = e.target;
        setAcao({
            ...acao,
            [name]: value
        })
    }

    //Função de load dos tipos de compensação
    const loadTiposCompensacao = () => {
        setLoading(true);
        tipoCompensacao_api.getList("Ativo").then(response => {
            response.data = response.data.map(value => ({ value: value.id.toString(), label: value.identificacao }));
            setTiposCompensacao(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que envia os dados da ação
    const acaoSelecionada = (acaoSelecionada) => {
        if (requerimento.etapaAtual.documentos && requerimento.etapaAtual.documentos.filter(doc => doc.obrigatorio && acao.documentos.filter(value => value.documento_Id == doc.id).length == 0).length > 0) {
            showMessage("Aviso", "Informe todos os documentos obrigatórios para continuar!", "info", null);
            return;
        }
        setErrors(false);
        if (acaoSelecionada.informarTipoCompensacao) {
            loadTiposCompensacao();
        }
        const _acao = {
            requerimento_Id: requerimento.id,
            tipoRequerimentoEtapaAcao_Id: acaoSelecionada.id,
            tipoRequerimentoEtapaProximaAcao_Id: acaoSelecionada.tipoRequerimentoEtapaProximaAcao_Id,
            acaoRealizada: acaoSelecionada.identificacao,
            identificacaoEtapa: requerimento.etapaAtual.identificacaoEtapa,
            dataHora: "",
            dataAgendamento: null,
            observacoes: acao.observacoes,
            tipoCompensacao_Id: acao.tipoCompensacao_Id,
            numeroProcesso: acao.numeroProcesso,
            responsavel: requerimento.etapaAtual.responsavel,
            requerAgendamento: acaoSelecionada.requerAgendamento,
            informarTipoCompensacao: acaoSelecionada.informarTipoCompensacao,
            informarNumeroProcesso: acaoSelecionada.informarNumeroProcesso,
            ...acaoSelecionada.formulario_Id ?
                {
                    formularios: [{
                        formulario_Id: acaoSelecionada.formulario_Id,
                        RequerimentoAcaoFormularioResposta: []
                    }]
                } : {},
            documentos: [...acao.documentos]
        };
        setAcao({
            ...acao,
            ..._acao
        })
        if (acaoSelecionada.formulario || acaoSelecionada.requerAgendamento || _acao.informarNumeroProcesso || _acao.informarTipoCompensacao) {
            setFormulario(acaoSelecionada.formulario ? acaoSelecionada.formulario : null);
            setQuestaoAtiva(acaoSelecionada.formulario ? { ...acaoSelecionada.formulario.formularioQuestos[0], valor: "" } : null);
            setLabelBtnSubmit(acaoSelecionada.formulario ? labelBtnSubmit : "Concluir");
            toggleModal();
        } else {
            if (!acaoSelecionada.formulario_Id)
                delete _acao.formulario;

            onSubmitAcao(_acao);
        }

    };

    //Função de envio dos dados da ação
    const onSubmitAcao = (acao) => {
        const _acao = {
            ...acao,
            formularios: acao?.formularios?.map(formulario => ({
                ...formulario,
                RequerimentoAcaoFormularioResposta: formulario?.RequerimentoAcaoFormularioResposta?.map(resposta => ({
                    ...resposta,
                    valor: Array.isArray(resposta.valor) ? resposta.valor.join(";") : resposta.valor
                }))
            }))
        };
        setLoading(true);
        _acao.dataHora = moment().format();
        requerimento_api.insertAcaoRequerimento(_acao).then(response => {
            showMessage("Sucesso!", "Ação realizada com sucesso!", "success", null);
            setAcao(initialStateAcao);
            loadRequerimento();
            if (_acao.formulario || !!_acao.dataAgendamento || _acao.informarNumeroProcesso || _acao.informarTipoCompensacao)
                toggleModal();
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de onChange da questão ativa
    const onChange = (e) => {
        const { value } = e.target;
        const _questaoAtiva = {
            ...questaoAtiva,
            valor: value,
        };
        setQuestaoAtiva(_questaoAtiva);
    }

    const onChangeMultiSelectRespostas = (e, select) => {
        const _questaoAtiva = {
            ...questaoAtiva,
            valor: e && e.length > 0 ? e.map(value => value.value) : []
        }
        setQuestaoAtiva(_questaoAtiva)
    }


    //Função que pega a proxima questão do formulario
    const proximaQuestao = () => {
        if (acao.requerAgendamento) {

            const _errors = validarCampos(acao, [objCampo({ name: "dataAgendamento", required: true })]);

            if (new Date(acao.dataAgendamento) < new Date(moment().format("YYYY-MM-DD"))) {
                _errors[0].dataAgendamento = { message: "" };
                _errors[1].push(objCampo({ name: "dataAgendamento", required: true }));
            }
            if (_errors[1].length > 0) {
                setErrors(_errors[0]);
                return;
            }
        }
        if ((acao.informarNumeroProcesso && !acao.numeroProcesso) || (acao.informarTipoCompensacao && !acao.tipoCompensacao_Id)) {
            setErrors(true);
            return;
        }
        if (!questaoAtiva) {
            onSubmitAcao(acao);
            return;
        }
        if (questaoAtiva.valor == "" && questaoAtiva.obrigatorio) {
            setErrors(true);
            return;
        }
        setErrors(false);

        //Salvando todas as questões que foram respondidas
        const _questoesRespondidas = [...questoesRespondidas, questaoAtiva];

        //Pegando todas as questões dependentes referente a questão que esta ativa
        const _questoesDependentes = formulario.formularioQuestos.filter(questao => questao.formularioQuestaoDependentes
            .filter(questaoDependente => questaoDependente.questaoPai_Id == questaoAtiva.id && questaoDependente.questaoPai_Valor == questaoAtiva.valor).length > 0
        );

        //Filtrando todas as questões que não foram respondidas
        const _questoesNaoRespondidas = formulario.formularioQuestos.filter(questao =>
            _questoesRespondidas
                .filter(questaoRespondida => questaoRespondida.id == questao.id).length == 0
            && questao.formularioQuestaoDependentes.length == 0
        );
        //Atualizandos os valores do preenchimento do formulario
        const _acao = {
            ...acao,
            formularios: [
                {
                    ...acao.formularios[0],
                    RequerimentoAcaoFormularioResposta: [
                        ...acao.formularios[0].RequerimentoAcaoFormularioResposta,
                        {
                            questao: questaoAtiva.questao,
                            valor: questaoAtiva.valor,
                            sequencia: questaoAtiva.sequencia,
                            formularioQuestao_Id: questaoAtiva.id
                        }
                    ]
                }
            ]
        }

        const _formulario = {
            ...formulario,
            formularioQuestos: formulario.formularioQuestos.map(value => {
                if (value.id == questaoAtiva.id) {
                    return questaoAtiva;
                }
                return value;
            })
        }

        //Atualizando as questões que foram respondidas
        setFormulario(_formulario);
        setAcao(_acao);
        setQuestoesRespondidas(_questoesRespondidas);

        //Setando a proxima questão a ser respondida por prioridade
        if (_questoesDependentes.length > 0) {
            setQuestaoAtiva({ ..._questoesDependentes[0], valor: "" });
        } else if (_questoesNaoRespondidas.length > 0) {
            setQuestaoAtiva({ ..._questoesNaoRespondidas[0], valor: "" });
        } else if (!((acao.informarNumeroProcesso && !acao.numeroProcesso) || (acao.informarTipoCompensacao && !acao.tipoCompensacao_Id))) {
            setQuestaoAtiva(null);
            onSubmitAcao(_acao);
        } else {
            setErrors(true);
            return;
        }
        if (_questoesNaoRespondidas.length <= 1)
            setLabelBtnSubmit("Concluir");
    }


    //Controle de visibilidade do modal de edição do agendamento
    const toggleModalEdicaoAgendamento = () => {
        setVisibleModalEdicaoAgendamento(!visibleModalEdicaoAgendamento);
        if (visibleModalEdicaoAgendamento) {
            setErrors(false);
            setAgendamento({
                id: "",
                dataAgendamento: ""
            })
        }
    }
    //função de onchange do agendamento a ser editado
    const onChangeAgendamento = (e) => {
        const { name, value } = e.target;
        setAgendamento({
            ...agendamento,
            [name]: value
        })
    }

    //Função de envio de edição do agendamento
    const atualizarAgendamento = () => {
        const _errors = validarCampos(agendamento, [objCampo({ name: "dataAgendamento", required: true })]);

        if (new Date(agendamento.dataAgendamento) < new Date(moment().format("YYYY-MM-DD"))) {
            _errors[0].dataAgendamento = { message: "" };
            _errors[1].push(objCampo({ name: "dataAgendamento", required: true }));
        }

        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return;

        setLoading(true);
        agenda_api.put(agendamento).then(response => {
            showMessage("Sucesso", "Agendamento atualizado com sucesso!", "success", null);
            toggleModalEdicaoAgendamento();
            loadRequerimento();
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    };

    return (
        <>
            <ModalCustomized className={"modalMenor"} title={"Imagem"} isOpen={imagemFormulario != null} toggle={() => setImagemFormulario(null)} btnClose={true}>
                <div className='w-100 d-flex align-items-center justify-content-center'>
                    {imagemFormulario != null &&
                        <img className='rounded-3' src={imagemFormulario} width={200} />
                    }
                </div>
            </ModalCustomized >
            <ModalCustomized className={"modalMenor"} title={formularioAgendamento && formularioAgendamento.nomeFormulario} isOpen={formularioAgendamento != null} toggle={() => setFormularioAgendamento(null)} btnClose={true}>
                <div className='w-100 d-flex align-items-center justify-content-center'>
                    {formularioAgendamento != null &&
                        <div className='d-flex align-items-start justify-content-start flex-column text-secondary w-100'>
                            {
                                formularioAgendamento.requerimentoAcaoFormularioResposta.map((resposta, index) => {
                                    return (
                                        <div className='col-md-12'>
                                            <p key={index}>
                                                <span className="fw-bold">{resposta.questao}</span> {resposta.valor}
                                                {resposta.imagem &&
                                                    <Button className='ms-3 px-2 py-0' color='primary' onClick={() => {
                                                        setImagemFormulario(resposta.imagem)
                                                    }}><FontAwesomeIcon size='xs' icon={faImage} /></Button>
                                                }
                                            </p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    }
                </div>
            </ModalCustomized >
            <ModalCustomized className={"modalMenor"} title={"Preencha os campos abaixo"} isOpen={visibleModal} toggle={toggleModal} btnClose={true}>
                {
                    acao.requerAgendamento &&
                    <div className='row'>
                        <div className='col-md-12'>
                            <TextField name={"dataAgendamento"} type={"date"} label={"Data do agendamento"} value={acao.dataAgendamento} onChange={onChangeAcao} invalid={errors != false && !!errors.dataAgendamento} />
                        </div>
                    </div>
                }
                <Row>
                    {
                        acao.informarTipoCompensacao &&
                        <div className={`col-md-12 col-lg-${acao.informarNumeroProcesso ? "6" : "12"}`}>
                            <TextField
                                label={<><span>*</span> Tipo de compensação</>}
                                name={"tipoCompensacao_Id"}
                                type={"select"}
                                searchable
                                options={tiposCompensacao}
                                value={tiposCompensacao.filter(value => value.value == acao.tipoCompensacao_Id)}
                                invalid={!!errors && !acao.tipoCompensacao_Id}
                                onChange={onChangeSearchable}
                            />
                        </div>
                    }

                    {
                        acao.informarNumeroProcesso &&
                        <div className={`col-md-12 col-lg-${acao.informarTipoCompensacao ? "6" : "12"}`}>
                            <TextField
                                maxLength={"30"}
                                name="numeroProcesso"
                                label={"* Número do processo"}
                                value={acao.numeroProcesso}
                                invalid={!!errors && !acao.numeroProcesso}
                                onChange={onChangeAcao}
                            />
                        </div>
                    }
                </Row>
                {
                    formulario &&
                    <>
                        <h5 className='mb-3 text-center'>{formulario.identificacao}</h5>
                        {questoesRespondidas.map((questaoRespondida, key) => {
                            return (
                                <TextField
                                    key={key}
                                    label={questaoRespondida.questao}
                                    type={typeOfFields[questaoRespondida.tipoValor] == "multiselect" ? "select" : typeOfFields[questaoRespondida.tipoValor]}
                                    value={typeOfFields[questaoRespondida.tipoValor] == "multiselect" ? questaoRespondida.formularioQuestoesOpcos
                                        .filter(opcao => questaoRespondida.valor && questaoRespondida.valor.includes(opcao.valor))
                                        .map(opcao => ({ value: opcao.valor, label: opcao.valor })) : questaoRespondida.valor
                                    }
                                    options={
                                        typeOfFields[questaoRespondida.tipoValor] == "multiselect" ?
                                            questaoRespondida.formularioQuestoesOpcos
                                                .filter(opcao => questaoRespondida.valor && questaoRespondida.valor.includes(opcao.valor))
                                                .map(opcao => ({ value: opcao.valor, label: opcao.valor }))
                                            :
                                            [
                                                { value: questaoRespondida.valor, label: questaoRespondida.valor }
                                            ]
                                    }
                                    multiple={typeOfFields[questaoRespondida.tipoValor] === "multiselect"}
                                    onChange={typeOfFields[questaoRespondida.tipoValor] === "multiselect" ? onChangeMultiSelectRespostas : onChange}
                                    disabled={true}
                                />
                            )
                        })}

                        {
                            questaoAtiva &&
                            <TextField
                                label={`${questaoAtiva.obrigatorio ? "* " : ""}${questaoAtiva.questao}`}
                                type={typeOfFields[questaoAtiva.tipoValor] == "multiselect" ? "select" : typeOfFields[questaoAtiva.tipoValor]}
                                value={typeOfFields[questaoAtiva.tipoValor] == "multiselect" ? questaoAtiva.formularioQuestoesOpcos
                                    .filter(opcao => questaoAtiva.valor && questaoAtiva.valor.includes(opcao.valor))
                                    .map(opcao => ({ value: opcao.valor, label: opcao.valor })) : questaoAtiva.valor
                                }
                                options={[
                                    { value: "", label: "Selecione uma opção" },
                                    ...((typeOfFields[questaoAtiva.tipoValor] === "select" || typeOfFields[questaoAtiva.tipoValor] === "multiselect")
                                        ? questaoAtiva.formularioQuestoesOpcos.map(value => {
                                            return { value: value.valor, label: value.valor };
                                        })
                                        : [])
                                ]}
                                multiple={typeOfFields[questaoAtiva.tipoValor] === "multiselect"}
                                onChange={typeOfFields[questaoAtiva.tipoValor] === "multiselect" ? onChangeMultiSelectRespostas : onChange}
                                invalid={!questaoAtiva.valor && questaoAtiva.obrigatorio && errors}
                            />
                        }
                    </>
                }
                <div className='d-flex align-items-center justify-content-center'>
                    <Button color='success' onClick={proximaQuestao}>{labelBtnSubmit}</Button>
                </div>
            </ModalCustomized>
            <ModalCustomized className={"modalMenor"} title={"Agendar fiscalização"} isOpen={visibleModalEdicaoAgendamento} toggle={toggleModalEdicaoAgendamento} btnClose={true}>

                <div className='row'>
                    <div className='col-md-12'>
                        <TextField name={"dataAgendamento"} type={"date"} label={"Data do agendamento"} value={agendamento.dataAgendamento} onChange={onChangeAgendamento} invalid={errors != false && !!errors.dataAgendamento} />
                    </div>
                </div>
                <div className='d-flex align-items-center justify-content-center'>
                    <Button color='warning text-white' onClick={atualizarAgendamento}><FontAwesomeIcon icon={faEdit} /> Editar</Button>
                </div>
            </ModalCustomized>
            {
                requerimento && requerimento.etapaAtual &&
                <div className='ps-2 contentGroup' style={{ position: "relative" }}>
                    {
                        requerimento.etapaAtual.agendamentosReplantio && requerimento.etapaAtual.agendamentosReplantio.length > 0 && requerimento.etapaAtual.agendamentosReplantio.some(value => value.status != "Executado")
                            ?
                            <div className='text-white pointHistory pending d-lg-flex d-md-none'>
                                <FontAwesomeIcon size='xs' icon={faHourglassHalf} />
                            </div>
                            :
                            <div className='text-white pointHistory d-lg-flex d-md-none'>
                                <FontAwesomeIcon size='xs' icon={faCheck} />
                            </div>
                    }
                    {!requerimento.etapaAtual.final &&
                        <div className='row pb-2 shadowFicha rounded-1 mt-4'>
                            <h5 className='py-2 titleFicha'>
                                {requerimento.etapaAtual.identificacaoEtapa}
                            </h5>
                            <div className='row'>
                                {
                                    ((session.perfil == "Municipe" && requerimento.etapaAtual.responsavel == "Requerente") || ((session.perfil == "Gestor" || session.perfil == "Master") && requerimento.etapaAtual.responsavel == "Gestor")) &&
                                    <>
                                        {!!documentos && documentos.length > 0 && <h6 className='w-100'>Anexe os documentos obrigatórios(*) abaixo:</h6>}

                                        <div className='d-flex flex-wrap align-items-center justify-content-center gap-3  w-100'>
                                            {
                                                documentos.map((value, index) => {
                                                    return (
                                                        <div key={index}>
                                                            <Button
                                                                key={index}
                                                                outline
                                                                color={acao.documentos.some(arquivoAdicionado => arquivoAdicionado.documento_Id == value.id) ? 'success' : 'secondary'}
                                                                onClick={() => handleClickCard(value.ref)}
                                                                style={{ position: "relative" }}
                                                            >
                                                                <FontAwesomeIcon icon={faFileUpload} />
                                                                <span className="ms-2">{(value.obrigatorio ? "*" : "") + value.identificacao}</span>
                                                                {value.orientacoes != "" &&
                                                                    <>
                                                                        <Tooltip placement="top" isOpen={value.toolTip} target={`Tooltip${value.id}`} toggle={() => toggleTooltip(value)}>
                                                                            {value.orientacoes}
                                                                        </Tooltip>
                                                                        <span id={`Tooltip${value.id}`} className="tooltipDocumento">?</span>
                                                                    </>
                                                                }
                                                            </Button>

                                                            {
                                                                value.base64 &&
                                                                <div className="mt-2">
                                                                    <Link
                                                                        role="button"
                                                                        className="text-primary"
                                                                        style={{ fontSize: "9pt" }}
                                                                        onClick={() => downloadArquivoDocumento(value)}
                                                                    >Baixar Modelo</Link>
                                                                </div>
                                                            }
                                                            {
                                                                value.conteudo &&
                                                                <div className="mt-2">
                                                                    <Link
                                                                        role="button"
                                                                        className="text-primary"
                                                                        style={{ fontSize: "9pt" }}
                                                                        onClick={() => {
                                                                            setDocumento(value)
                                                                        }}
                                                                    >Baixar Modelo</Link>
                                                                </div>
                                                            }
                                                            <input
                                                                type="file"
                                                                ref={value.ref}
                                                                onChange={(e) => handleFileChange(value, e, value)}
                                                                style={{ display: "none" }}
                                                            />
                                                        </div>
                                                    )
                                                })

                                            }
                                        </div>
                                    </>
                                }
                                {((session.perfil == "Municipe" && requerimento.etapaAtual.responsavel == "Requerente") || ((session.perfil == "Gestor" || session.perfil == "Master") && requerimento.etapaAtual.responsavel == "Gestor")) && editavel &&
                                    <>

                                        {requerimento?.etapaAtual?.acoes?.length > 0 &&
                                            <div className='col-md-12'>
                                                <TextField name="observacoes" label={"Observações"} type={"textarea"} value={acao.observacoes} onChange={onChangeAcao} />
                                            </div>
                                        }
                                        <div className='col-md-12'>

                                            {
                                                requerimento.etapaAtual.acoes.map((value, index) => {
                                                    return (
                                                        <Button key={index} className='me-4' color={value.cor} onClick={() => acaoSelecionada(value)}>
                                                            {value.identificacao}
                                                        </Button>
                                                    )
                                                })
                                            }
                                        </div>
                                    </>
                                }

                            </div>
                            {(!((session.perfil == "Municipe" && requerimento.etapaAtual.responsavel == "Requerente") || ((session.perfil == "Gestor" || session.perfil == "Master") && requerimento.etapaAtual.responsavel == "Gestor")) || !editavel) &&
                                <div className='col-md-12'>
                                    <p>Aguardando a resposta do {requerimento.etapaAtual.responsavel}</p>
                                </div>
                            }
                        </div>
                    }
                    {
                        requerimento.etapaAtual.agendamentosReplantio && requerimento.etapaAtual.agendamentosReplantio.length > 0 &&
                        <>
                            <div className="mt-4 mb-4 noPrint">
                                <TabelaListagem headers={headers} actions={actions} title='Tabela de agendamentos de replantio' items={requerimento.etapaAtual.agendamentosReplantio} />
                            </div>
                            <div className="print mb-5">
                                <h5 className='py-2 titleFicha close mb-5'>Requerimento Finalizado</h5>
                            </div>
                        </>
                    }
                </div >
            }
        </>
    )
}